import { Box, BoxProps } from '@bitrise/bitkit';

import BuildListSkeletonContent from './BuildListSkeletonContent';

export type BuildListSkeletonOverlayContentProps = { showAppInfo?: boolean } & BoxProps;
const BuildListSkeletonOverlayContent = ({
  showAppInfo,
  children,
  ...rest
}: BuildListSkeletonOverlayContentProps): JSX.Element => (
  <Box position="relative">
    <BuildListSkeletonContent active={false} count={3} showAppInfo={showAppInfo} />
    <Box
      width="100%"
      height="100%"
      position="absolute"
      top="0"
      left="0"
      backgroundImage="linear-gradient(180deg, rgba(255,255,255, 0.25) 0%, white 85%, white 100%)"
    />
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      gap="16"
      alignItems="center"
      justifyContent="center"
      position="absolute"
      top="0"
      left="0"
      {...rest}
    >
      {children}
    </Box>
  </Box>
);

export default BuildListSkeletonOverlayContent;
